export default __webpack_public_path__ + "static/screeny-130-gpz-unica-m-1-3b2949db5c88df2e344accd3b1344059.jpg";